/* Porter Media 21/10/2026: behaviour for the Pagedeck-exact postpartum page (template page.zend-postpartum-pd).
   Replaces Pagedeck's React and Flickity bundles with the few interactions the page needs:
   hero gallery, plan selector, carousels, FAQ and the sticky buy bar. No libraries. */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function addSwipe(el, onLeft, onRight) {
    var startX = null, startY = null;
    el.addEventListener('pointerdown', function (e) { startX = e.clientX; startY = e.clientY; });
    el.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      startX = null;
      if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy)) return;
      if (dx < 0) onLeft(); else onRight();
    });
    el.style.touchAction = 'pan-y';
  }

  /* Hero gallery: main image strip (Flickity markup, moved with a transform) plus a scrollable thumbnail row. */
  function initGallery(gallery) {
    var slider = gallery.querySelector('.product-main-gallery .flickity-slider');
    if (!slider) return;
    var cells = Array.prototype.slice.call(slider.children);
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.product-thumbnails > .image'));
    var current = 0;

    function select(i) {
      current = (i + cells.length) % cells.length;
      slider.style.transform = 'translateX(' + (-100 * current) + '%)';
      cells.forEach(function (c, n) {
        c.classList.toggle('is-selected', n === current);
        if (n === current) c.removeAttribute('aria-hidden'); else c.setAttribute('aria-hidden', 'true');
      });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-selected', n === current); });
    }

    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { select(n); }); });
    var viewport = gallery.querySelector('.product-main-gallery .flickity-viewport');
    if (viewport) addSwipe(viewport, function () { select(current + 1); }, function () { select(current - 1); });
    slider.style.transition = 'transform .35s ease';
  }

  /* Plan selector: same behaviour as try. (click a plan, its feature list opens, Buy Now points at its checkout link). */
  function initBuyBoxes() {
    var boxes = Array.prototype.slice.call(document.querySelectorAll('.buy-box'));
    var atc = document.querySelector('.atc-button a');
    if (!boxes.length) return;

    function update(animate) {
      boxes.forEach(function (box) {
        var list = box.querySelector('.buy-box-features');
        if (!list) return;
        if (box.classList.contains('selected')) {
          var inner = list.querySelector('ul');
          list.style.height = (inner ? inner.offsetHeight : list.scrollHeight) + 'px';
        } else {
          list.style.height = '0px';
        }
        if (!animate) list.style.transition = 'none';
        else list.style.transition = '';
      });
      var sel = document.querySelector('.buy-box.selected') || boxes[0];
      var url = sel.getAttribute('data-url');
      if (url && atc) atc.setAttribute('href', url);
    }

    boxes.forEach(function (box) {
      box.addEventListener('click', function () {
        boxes.forEach(function (b) { b.classList.remove('selected'); });
        box.classList.add('selected');
        update(true);
      });
    });
    update(false);
    window.addEventListener('resize', function () { update(false); });
  }

  /* Carousels (reviews, ingredients, how-to on phones): one card per click, arrows disabled at the ends, swipe on touch. */
  function initCarousel(track) {
    var wrap = track.closest('.relative.overflow-hidden') || track.parentElement;
    var root = wrap.parentElement;
    var prev = root.querySelector('.carousel__button-prev');
    var next = root.querySelector('.carousel__button-next');
    if (!prev || !next) return;
    var index = 0;

    function metrics() {
      var slides = Array.prototype.slice.call(track.children);
      var w = slides.length ? slides[0].getBoundingClientRect().width : 0;
      var visible = w ? Math.max(1, Math.round(wrap.getBoundingClientRect().width / w)) : 1;
      return { count: slides.length, width: w, max: Math.max(0, slides.length - visible) };
    }

    function go(i) {
      var m = metrics();
      index = Math.max(0, Math.min(i, m.max));
      track.style.transition = 'transform .4s ease';
      track.style.transform = 'translate3d(' + (-index * m.width) + 'px, 0px, 0px)';
      prev.disabled = index <= 0;
      next.disabled = index >= m.max;
    }

    prev.addEventListener('click', function (e) { e.preventDefault(); go(index - 1); });
    next.addEventListener('click', function (e) { e.preventDefault(); go(index + 1); });
    addSwipe(wrap, function () { go(index + 1); }, function () { go(index - 1); });
    window.addEventListener('resize', function () { track.style.transition = 'none'; go(index); });
    go(0);
  }

  /* FAQ: same open/close states as Pagedeck's accordion (chevron turns, answer shows). */
  function initFaq() {
    document.querySelectorAll('div.faq__item').forEach(function (item) {
      var btn = item.querySelector('button');
      var panel = item.querySelector('dd.faq__content');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', String(open));
        var state = open ? 'open' : '';
        btn.setAttribute('data-headlessui-state', state);
        item.setAttribute('data-headlessui-state', state);
        panel.hidden = !open;
        var svg = btn.querySelector('svg');
        if (svg) {
          svg.classList.toggle('rotate-0', !open);
          svg.classList.toggle('-rotate-180', open);
        }
      });
    });
  }

  /* Sticky buy bar: slides up once the visitor scrolls past the first reviews block, like try. */
  function initStickyBar() {
    var bar = document.getElementById('sticky-bar');
    var trigger = document.getElementById('sticky-trigger');
    if (!bar || !trigger) return;
    function update() { bar.classList.toggle('appear', trigger.getBoundingClientRect().top <= 0); }
    document.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  onReady(function () {
    document.querySelectorAll('.product-gallery').forEach(initGallery);
    initBuyBoxes();
    document.querySelectorAll('.carousel__viewport, .carousel__list').forEach(initCarousel);
    initFaq();
    initStickyBar();
  });
})();
